"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _us_flag = _interopRequireDefault(require("../../img/flags/us_flag.svg"));
var _spanish_flag = _interopRequireDefault(require("../../img/flags/spanish_flag.svg"));
var _german_flag = _interopRequireDefault(require("../../img/flags/german_flag.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function LanguageSelector() {
  const [selected, setSelected] = (0, _react.useState)('en');
  const selectionChangeHandler = event => {
    setSelected(event.target.value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
    size: "small",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select.default, {
      value: selected,
      variant: "outlined",
      title: "Language Selection",
      "aria-label": "Language Selection",
      onChange: selectionChangeHandler,
      sx: {
        height: '30px'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
        value: 'en',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          component: 'img',
          src: _us_flag.default,
          height: 15,
          width: 20,
          marginRight: 0.5
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: 'caption',
          color: "text.secondary",
          children: "English"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
        value: 'es',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          component: 'img',
          src: _spanish_flag.default,
          height: 15,
          width: 20,
          marginRight: 0.5
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: 'caption',
          color: "text.secondary",
          children: "Spanish"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
        value: 'de',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          component: 'img',
          src: _german_flag.default,
          height: 15,
          width: 20,
          marginRight: 0.5
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: 'caption',
          color: "text.secondary",
          children: "German"
        })]
      })]
    })
  });
}
var _default = exports.default = LanguageSelector;